"use strict";

export { ComposedGestureName, SingleGestureName } from './GestureTypes';
//# sourceMappingURL=index.js.map